import Axios from 'axios'

import ConfigLoader from './bootstrap/config-loader'

import AppLoader from './bootstrap/app-loader'

import Header from './bootstrap/header'

import Sidebar from './bootstrap/sidebar'

import Authenticate from './bootstrap/authenticate'

import GoogleTagManager from './bootstrap/google-tag-manager'

import app from './app';

app.init();

/**
function getToken() {
    let url_string = window.location.href;
    let url = new URL(url_string);

    return url.searchParams.get('token');
}

function getCookie(name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");

    if (parts.length == 2) {
        return parts.pop().split(";").shift();
    }
}

/**
let token = getToken();





if(token) {
    document.cookie = "bs_token=" + token;
    document.cookie = "bs_language=no";
    location.href = '/';

}**/

//Authenticate.init();
/**
let profile = getCookie('bs_profile');
let lang = getCookie('bs_language');
let messages = {};

ConfigLoader.init(profile, getCookie('bs_token'), () => {
    //Bootstrap the app loader

    AppLoader.run(location.pathname + location.hash, window.brandsafe_app_config, lang)

    GoogleTagManager.init();

    Axios.get('https://modules.brandsafe.no/translations/wrapper/' + lang + '.json').then((response) => {
        // Sidebar.init(window.brandsafe_app_config, response.data.data);
        messages[lang] = response.data;
        //Bootstrap the header
        Header.init(messages, lang);

        //Bootstrap the sidebar
        Sidebar.init(window.brandsafe_app_config, messages, lang);
    }).catch((error) => {
        Sidebar.init(window.brandsafe_app_config, {});
    });
});**/
